import ErrorModal from './ErrorModal.view';

export default ErrorModal;
